


























































import mixins from 'vue-typed-mixins';
import SubOrganizationUtils, {
  SubOrganization,
} from '@/utils/SubOrganizationUtils';
import cloneDeep from 'lodash.clonedeep';
import deepEqual from 'deep-equal';
import { ReportNode, QuestionData, ReportContext } from '@/utils/ReportUtils';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },

    context: {
      type: Object as () => ReportContext,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },
  },

  data(): {
    internal: Partial<SubOrganization>[];
    pristine: Partial<SubOrganization>[];
    removeList: Partial<SubOrganization>[];
  } {
    return {
      internal: [],
      pristine: [],
      removeList: [],
    };
  },

  mounted() {
    this.internal = cloneDeep(this.context.suborganizations || []);
    this.pristine = cloneDeep(this.internal);
  },

  watch: {
    'answer.hasSubOrgs'(current, previous) {
      if (current === false && previous !== undefined) {
        this.internal.forEach((item, index) => {
          if (this.internal[index].id) {
            this.removeList.push(this.internal[index]); // if it has an id it must be removed from the server on save
          }
        });
        this.internal = [];
        this.handleChange();
      }
    },
  },

  methods: {
    async before() {
      if (!this.context.mode.includes('preview')) {
        const saveList = this.internal
          ?.map((suborg, index) => ({
            ...suborg,
            order: index,
            action: suborg.id ? 'update' : 'add',
          }))
          ?.concat(
            this.removeList.map((suborg) => ({
              ...suborg,
              action: 'delete',
            })) as any
          );

        const data = await SubOrganizationUtils.api.save(saveList as any);
        data?.forEach((suborg) => {
          delete suborg.action;
        });

        this.internal = data;
      }

      this.context.suborganizations = cloneDeep(
        this.internal
      ) as SubOrganization[];
      this.pristine = cloneDeep(this.internal);
      this.removeList = [];
    },

    create() {
      this.internal?.push({
        survey: { id: this.context.survey?.id },
        surveyparticipation: { id: this.context.surveyParticipation?.id },
        question: { id: this.value.item.id },
        name: this.$languageobj(),
      });
      this.$nextTick(() => this.handleChange());
    },

    async remove(index: number) {
      if (this.internal) {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [
              this.$translate(this.internal[index].name),
            ])
            .toString(),
          async () => {
            if (this.internal) {
              if (this.internal[index].id) {
                // if it has an id it must be removed from the server on save
                this.removeList.push(this.internal[index]);
              }
              this.internal?.splice(index, 1);
              this.$nextTick(() => this.handleChange());
            }
          }
        );
      }
    },

    async handleChange() {
      this.$emit('dirty');

      if (this.value.data.participation) {
        let completeness = 0;
        if (this.answer.hasSubOrgs !== undefined) {
          if (this.answer.hasSubOrgs === true) {
            if (this.internal && this.internal.length > 0) {
              if (!(await (this.$refs.observer as any).validate())) {
                this.value.data.valid = false;
              } else {
                this.value.data.valid = true;
              }
              // this.value.data.valid = true;
              completeness++;
            } else {
              this.value.data.valid = false;
            }
          } else if (this.answer.hasSubOrgs === false) {
            this.value.data.valid = true;
            completeness++;
          }
        }
        this.value.data.participation.completeness = completeness / 1;
      }
    },

    move(evt: any) {
      return !this.readonly;
    },
  },
});
